module.exports = __webpack_public_path__ + "static/img/Surplus.35a7a113.jpeg";